import { ShopFilterItem } from "../models/filter-item.model";
import { SortingItem } from "../models/sorting-item.model";

export const TYPING_DELAY = 750;

export const DEFAULT_PRODUCT_IMAGE = 'assets/shop/images/placeholder_image.png';
export const DEFAULT_PALLETE_IMAGE = 'assets/shop/images/placeholder_image.png';
export const DEFAULT_ASSORTMENT_IMAGE = 'assets/shop/images/placeholder_image.png';

export const SIZES_RANGE = ['xxs', 'yxxs', 'xs', 'yxs', 's', 'ys', 'm', 'ym', 'l', 'yl', 'xl', 'yxl', '2xl', 'y2xl', 'xxl', 'yxxl', '3xl', 'y3xl', 'xxxl', 'yxxxl', '4xl', 'y4xl', 'xxxxl', 'yxxxxl', '5xl', 'y5xl', 'xxxxxl', 'yxxxxxl', '6xl', 'y6xl', 'xxxxxxl', 'yxxxxxxl'];

export const AVAILABLE_PRODUCTS_FILTERS = [
  {
    name: 'Strategic only',
    field: 'strategicOnly',
    type: 'boolean'
  },
  {
    name: 'Promo only',
    field: 'promoOnly',
    type: 'boolean'
  },
  {
    name: 'Available now',
    field: 'availableNow',
    type: 'boolean'
  },
  {
    name: 'Gender',
    field: 'genders',
    type: 'number-array'
  },
  {
    name: 'Size group',
    field: 'sizeGroups',
    type: 'number-array'
  },
  {
    name: 'Color',
    field: 'colors',
    type: ''
  },
  {
    name: 'Category',
    field: 'categories',
    type: 'number-array'
  },
  {
    name: 'Purpose',
    field: 'purposes',
    type: 'number-array'
  },
  {
    name: 'Assortment',
    field: 'assortments',
    type: 'number-array'
  },
  {
    name: 'Team',
    field: 'teams',
    type: 'number-array'
  },
  {
    name: 'Season',
    field: 'seasons',
    type: 'number-array'
  },
  {
    name: 'Availability',
    field: 'availability',
    type: 'date'
  },
  {
    name: 'Wholesale price',
    field: ['wholesalePriceFrom', 'wholesalePriceTo'],
    type: 'range',
    isCurrency: true
  },
  {
    name: 'Suggested retail price',
    field: ['retailPriceFrom', 'retailPriceTo'],
    type: 'range',
    isCurrency: true
  }
];
export const BROWSE_BY_LIST: Array<SortingItem> = [
  new SortingItem({ label: 'Styles', field: 'styles' }),
  new SortingItem({ label: 'Assortments', field: 'assortments' })
];
export const ORDER_BY_LIST: Array<SortingItem> = [
  new SortingItem({ label: 'Latest arrival', field: null }),
  new SortingItem({ label: 'Alph. A-Z', field: 'name asc' }),
  new SortingItem({ label: 'Alph. Z-A', field: 'name desc' })
];

export const SIZE_GROUPS: Array<ShopFilterItem> = [
  new ShopFilterItem({
    name: 'Adult',
    id: 0
  }),
  new ShopFilterItem({
    name: 'Youth',
    id: 1
  }),
  new ShopFilterItem({
    name: 'Kid',
    id: 2
  }),
  new ShopFilterItem({
    name: 'Infant',
    id: 3
  })
];

export const GENDERS: Array<ShopFilterItem> = [
  new ShopFilterItem({
    name: 'Male',
    id: 0
  }),
  new ShopFilterItem({
    name: 'Female',
    id: 1
  }),
  new ShopFilterItem({
    name: 'Unisex',
    id: 2
  })
];
